<div class="home-page flex h-full min-h-0 flex-col gap-3">
  <app-loader
    [isLoading]="isLoading"
    [message]="'HOME.LOADING' | translate"
  ></app-loader>
  <div *ngIf="errorMsg" class="alert alert-warning mt-2">{{ errorMsg }}</div>

  <div
    class="grid-main grid flex-[3] min-h-0 gap-y-6 gap-x-4 auto-rows-[minmax(0,1fr)] xl:grid-cols-[1fr_2fr]"
  >
    <div class="card map-card flex min-h-0 flex-col p-0 w-full gap-0">
      <div
        class="map-select-row flex items-center justify-end gap-2 px-4 pt-1 pb-0"
      >
        <mat-form-field appearance="outline" class="select-field min-w-[180px]">
          <mat-label>{{ 'HOME.SELECT.FINCA_LABEL' | translate }}</mat-label>
          <mat-select
            panelClass="home-select-panel"
            [value]="fincaSelected"
            (openedChange)="onSelectOpened($event)"
            (selectionChange)="fincaChange($event.value)"
          >
            <mat-option *ngIf="!isAdminUser" [value]="-1">
              {{ 'HOME.SELECT.ALL_FINCAS' | translate }}
            </mat-option>
            <mat-option *ngIf="fincas.length === 0" [value]="-1">
              {{ 'HOME.SELECT.NO_FINCAS' | translate }}
            </mat-option>
            <mat-option *ngFor="let finca of fincas" [value]="finca.idFinca">
              {{ finca.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="select-field compact min-w-[140px]"
        >
          <mat-label>{{ 'HOME.SELECT.RANGE_LABEL' | translate }}</mat-label>
          <mat-select
            [value]="selectedRange"
            (openedChange)="onSelectOpened($event)"
            (selectionChange)="onRangeChange($event.value)"
          >
            <mat-option
              *ngFor="let option of rangeOptions"
              [value]="option.value"
            >
              {{ option.labelKey | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="map-inner mt-1 flex flex-1 min-h-0 rounded-xl bg-white p-3">
        <div
          class="map-wrapper relative flex-1 min-h-0 overflow-hidden rounded-lg border border-dashed bg-gradient-to-br from-slate-50 to-slate-200"
        >
          <div class="map-google absolute inset-0" #mapContainer></div>
          <div
            class="map-overlay"
            *ngIf="modulos.length === 0 || !hasValidCoords"
          >
            <div class="muted">
              {{
                modulos.length === 0
                  ? ('HOME.MAP.NO_MODULES' | translate)
                  : ('HOME.MAP.NO_COORDS' | translate)
              }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sensor-panel flex h-full min-h-0 flex-col gap-3">
      <div class="card sensor-chart-card flex flex-1 min-h-0 flex-col pt-1.5">
        <div class="sensor-chart-wrapper relative flex-1 min-h-0">
          <div class="sensor-chart flex-1 min-h-0" id="sensor-main-chart"></div>
          <div
            *ngIf="!sensorChartHasData"
            class="sensor-chart-empty absolute inset-0 flex min-h-0 items-center justify-center"
          >
            <div class="muted text-center">
              {{ 'HOME.CHART.NO_DATA' | translate }}
            </div>
          </div>
        </div>
      </div>

      <div class="card sensor-readings-card flex flex-col pt-1.5">
        <div
          class="readings-grid grid auto-rows-[minmax(0,1fr)] grid-cols-[repeat(auto-fit,minmax(140px,1fr))] gap-2"
        >
          <div class="reading-item" *ngIf="showHumidity">
            <div class="reading-label">
              <mat-icon class="reading-icon text-emerald-600"
                >water_drop</mat-icon
              >
              {{ 'HOME.READINGS.HUMIDITY' | translate }}
            </div>
            <div class="reading-value text-emerald-700">
              {{
                soilMoistureValue !== null && soilMoistureValue !== undefined
                  ? soilMoistureValue
                  : '-'
              }}
              <span class="unit text-emerald-500">%</span>
            </div>
          </div>
          <div class="reading-item" *ngIf="showTemperature">
            <div class="reading-label">
              <mat-icon class="reading-icon text-orange-600"
                >thermostat</mat-icon
              >
              {{ 'HOME.READINGS.TEMPERATURE' | translate }}
            </div>
            <div class="reading-value text-orange-700">
              {{
                temperatureValue !== null && temperatureValue !== undefined
                  ? temperatureValue
                  : '-'
              }}
              <span class="unit text-orange-500">&deg;C</span>
            </div>
          </div>
          <div class="reading-item" *ngIf="showIrrigation">
            <div class="reading-label">
              <mat-icon class="reading-icon text-blue-600">water_drop</mat-icon>
              {{ 'HOME.READINGS.IRRIGATION' | translate }}
            </div>
            <div class="reading-value text-blue-700">
              {{
                dailyIrrigationValue !== null &&
                dailyIrrigationValue !== undefined
                  ? dailyIrrigationValue
                  : '-'
              }}
              <span class="unit text-blue-500">mm</span>
            </div>
          </div>
          <div class="reading-item" *ngIf="showDigital">
            <div class="reading-label">
              <mat-icon class="reading-icon text-indigo-600">
                toggle_on</mat-icon
              >
              {{ 'HOME.READINGS.DIGITAL' | translate }}
            </div>
            <div class="reading-value text-indigo-700">
              {{
                digitalValue !== null && digitalValue !== undefined
                  ? (digitalValue
                      ? ('HOME.STATUS.ON' | translate)
                      : ('HOME.STATUS.OFF' | translate))
                  : '-'
              }}
            </div>
          </div>
          <div class="reading-item" *ngIf="showRain">
            <div class="reading-label">
              <mat-icon class="reading-icon text-sky-600"
                >cloudy_snowing</mat-icon
              >
              {{ 'HOME.READINGS.RAIN' | translate }}
            </div>
            <div class="reading-value text-sky-700">
              {{
                dailyRainValue !== null && dailyRainValue !== undefined
                  ? dailyRainValue
                  : '-'
              }}
              <span class="unit text-sky-500">mm</span>
            </div>
          </div>
          <div class="reading-item" *ngIf="showConductivity">
            <div class="reading-label">
              <mat-icon class="reading-icon text-emerald-600">water</mat-icon>
              {{ 'HOME.READINGS.CONDUCTIVITY' | translate }}
            </div>
            <div class="reading-value text-emerald-700">
              {{
                conductividad !== null && conductividad !== undefined
                  ? conductividad
                  : '-'
              }}
              <span class="unit text-emerald-500">mS/cm</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="grid-secondary grid flex-[1] gap-3 lg:grid-cols-[1.6fr_1fr]">
    <div
      class="card table-card modules-card-compact flex flex-col overflow-hidden py-2"
    >
      <div class="card-header">
        <div class="card-title">{{ 'HOME.MODULES.TITLE' | translate }}</div>
      </div>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>{{ 'HOME.MODULES.NAME' | translate }}</th>
              <th>{{ 'HOME.MODULES.ENABLED' | translate }}</th>
              <th>{{ 'HOME.MODULES.BATTERY' | translate }}</th>
              <th>{{ 'HOME.MODULES.COVERAGE' | translate }}</th>
              <th>{{ 'HOME.MODULES.LAST_UPDATE' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let modulo of modulos"
              (click)="moduloChange(modulo.idModule)"
              class="row-clickable"
              [class.selected]="modulo.idModule === moduloSelected"
            >
              <td>
                <span class="module-name">
                  {{ modulo.name }}
                  <mat-icon
                    *ngIf="modulo.idModule === moduloSelected"
                    class="selected-icon"
                    aria-label="Seleccionado"
                    >check_circle</mat-icon
                  >
                </span>
              </td>
              <td>
                <span
                  class="dot"
                  [class.off]="modulo.isEnabled === false"
                ></span>
                <span>{{
                  modulo.isEnabled === false
                    ? ('HOME.STATUS.OFF' | translate)
                    : ('HOME.STATUS.ON' | translate)
                }}</span>
              </td>
              <td>
                <div class="status-cell">
                  <span
                    class="icon-battery"
                    [style.--level]="getBatteryLevel(modulo.batteryPercent ?? modulo.batteryCapacity)"
                    [style.--battery-color]="getBatteryColor(modulo.batteryPercent ?? modulo.batteryCapacity)"
                  ></span>
                  <span class="status-text">
                    {{ formatBattery(modulo.batteryPercent ?? modulo.batteryCapacity) }}
                  </span>
                </div>
              </td>
              <td>
                <div class="status-cell">
                  <span
                    class="icon-coverage"
                    [attr.data-level]="(modulo.signalPercent ?? modulo.coverage ?? modulo.signalStrength ?? 0) >= 67 ? 3 : (modulo.signalPercent ?? modulo.coverage ?? modulo.signalStrength ?? 0) >= 34 ? 2 : 1"
                    [class.no-signal]="!(modulo.signalPercent ?? modulo.coverage ?? modulo.signalStrength)"
                  >
                    <svg
                      viewBox="0 0 24 18"
                      aria-hidden="true"
                      class="wifi-icon"
                    >
                      <path class="wifi-arc arc-3" d="M2 6c5.5-5 14.5-5 20 0" />
                      <path
                        class="wifi-arc arc-2"
                        d="M5 9c3.8-3.6 10.2-3.6 14 0"
                      />
                      <path class="wifi-arc arc-1" d="M8 12c2.2-2 5.8-2 8 0" />
                      <circle class="wifi-dot" cx="12" cy="16" r="1.7" />
                    </svg>
                  </span>
                  <span class="status-text">
                    {{ (modulo.signalPercent ?? modulo.coverage ?? modulo.signalStrength ?? null) !== null ? (modulo.signalPercent ?? modulo.coverage ?? modulo.signalStrength) + '%' : '-' }}
                  </span>
                </div>
              </td>
              <td>
                {{
                  modulo.lastSentOn
                    ? (modulo.lastSentOn | date: 'dd/MM/yyyy, HH:mm:ss')
                    : lastUpdatedText || '-'
                }}
              </td>
            </tr>
            <tr *ngIf="modulos.length === 0">
              <td colspan="5" class="muted text-center py-3">
                {{ 'HOME.MODULES.NO_MODULES_SELECTED' | translate }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="modules-list-mobile" *ngIf="modulos.length > 0">
        <div
          class="module-card"
          *ngFor="let modulo of modulos"
          (click)="moduloChange(modulo.idModule)"
          [class.selected]="modulo.idModule === moduloSelected"
        >
          <div class="module-card__row module-card__row--name">
            <div class="module-card__name">
              {{ modulo.name }}
              <mat-icon
                *ngIf="modulo.idModule === moduloSelected"
                class="selected-icon"
                aria-label="Seleccionado"
                >check_circle</mat-icon
              >
            </div>
            <div class="module-card__status">
              <span class="dot" [class.off]="modulo.isEnabled === false"></span>
              <span>{{
                modulo.isEnabled === false
                  ? ('HOME.STATUS.OFF' | translate)
                  : ('HOME.STATUS.ON' | translate)
              }}</span>
            </div>
          </div>
          <div class="module-card__row module-card__row--meta">
            <div class="status-cell">
              <span
                class="icon-battery"
                [style.--level]="getBatteryLevel(modulo.batteryPercent ?? modulo.batteryCapacity)"
                [style.--battery-color]="getBatteryColor(modulo.batteryPercent ?? modulo.batteryCapacity)"
              ></span>
              <span class="status-text">
                {{ formatBattery(modulo.batteryPercent ?? modulo.batteryCapacity) }}
              </span>
            </div>
            <div class="status-cell">
              <span
                class="icon-coverage"
                [attr.data-level]="(modulo.signalPercent ?? modulo.coverage ?? modulo.signalStrength ?? 0) >= 67 ? 3 : (modulo.signalPercent ?? modulo.coverage ?? modulo.signalStrength ?? 0) >= 34 ? 2 : 1"
                [class.no-signal]="!(modulo.signalPercent ?? modulo.coverage ?? modulo.signalStrength)"
              >
                <svg viewBox="0 0 24 18" aria-hidden="true" class="wifi-icon">
                  <path class="wifi-arc arc-3" d="M2 6c5.5-5 14.5-5 20 0" />
                  <path class="wifi-arc arc-2" d="M5 9c3.8-3.6 10.2-3.6 14 0" />
                  <path class="wifi-arc arc-1" d="M8 12c2.2-2 5.8-2 8 0" />
                  <circle class="wifi-dot" cx="12" cy="16" r="1.7" />
                </svg>
              </span>
              <span class="status-text">
                {{ (modulo.signalPercent ?? modulo.coverage ?? modulo.signalStrength ?? null) !== null ? (modulo.signalPercent ?? modulo.coverage ?? modulo.signalStrength) + '%' : '-' }}
              </span>
            </div>
          </div>
          <div class="module-card__row module-card__row--foot">
            <span class="muted">{{
              'HOME.MODULES.LAST_UPDATE' | translate
            }}</span>
            <span class="status-text">{{
              modulo.lastSentOn
                ? (modulo.lastSentOn | date: 'dd/MM/yyyy, HH:mm:ss')
                : lastUpdatedText || '-'
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <div
      class="card aemet-card aemet-card-compact flex flex-col py-2"
      *ngIf="weatherForecast.length > 0"
    >
      <div class="card-header">
        <div class="card-title">{{ 'HOME.AEMET.TITLE' | translate }}</div>
      </div>
      <div
        class="aemet-grid grid grid-cols-[repeat(auto-fit,minmax(140px,1fr))] gap-2"
      >
        <div class="aemet-day" *ngFor="let day of weatherForecast | slice: 0:3">
          <div class="aemet-date">{{ day.date | date: 'E dd' }}</div>
          <div class="aemet-temp">
            <img
              class="aemet-icon-img"
              [src]="getForecastIconUrl(day)"
              [alt]="day.conditionText || 'Forecast'"
            />
            <span>{{ day.min }}&deg; / {{ day.max }}&deg;</span>
          </div>
          <div class="aemet-rain">
            <mat-icon class="aemet-mini">water_drop</mat-icon>
            {{ day.rain }}% -
            {{
              day.rainMm !== null && day.rainMm !== undefined
                ? (day.rainMm | number: '1.0-0')
                : '-'
            }}
            mm
          </div>
          <div class="aemet-wind">
            <mat-icon class="aemet-mini">air</mat-icon>
            {{ day.windDir }} - {{ day.windKph }} km/h
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
